import React from "react";
import { Link } from "react-router-dom";

import logo from "../assets/logo.png";
import hero from "../assets/Hero.png";
import about from "../assets/About.png";
import services from "../assets/services.png";
import ceo from "../assets/ceo.png";
import contact from "../assets/contact.png";

const Home = () => {
  return (
    <div className="text-white overflow-hidden">

      {/* ================= HERO ================= */}
      <section
        className="relative h-screen flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>

        <div className="relative z-10 px-6 animate-fadeIn">

          <img
            src={logo}
            alt="TheLogicWaves Logo"
            className="w-32 md:w-40 mx-auto mb-6 animate-float"
          />

          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
            Innovate. Build. Scale.
            <span className="block bg-gradient-to-r from-purple-400 to-pink-500 text-transparent bg-clip-text">
              TheLogicWaves
            </span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto text-lg">
            Transforming ideas into powerful digital solutions with cutting-edge
            design and development.
          </p>

          <div className="mt-8 flex justify-center gap-4 flex-wrap">
            <Link to="/services">
              <button className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
                Our Services
              </button>
            </Link>

            <Link to="/portfolio">
              <button className="px-6 py-3 border border-white rounded-lg hover:bg-white hover:text-black transition">
                View Portfolio
              </button>
            </Link>
          </div>
        </div>
      </section>

  {/* ================= ABOUT (ENHANCED) ================= */}
<section
  className="relative py-24 px-6 flex items-center"
  style={{
    backgroundImage: `url(${about})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Dark overlay */}
  <div className="absolute inset-0 bg-black/80"></div>

  <div className="relative z-10 max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">

    {/* LEFT TEXT */}
    <div className="animate-slideLeft">
      <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
        Who We Are
        <span className="block text-purple-400">
          TheLogicWaves
        </span>
      </h2>

      <p className="text-gray-300 mb-6 leading-relaxed text-lg">
        We are a modern digital agency focused on building powerful,
        scalable, and visually stunning digital products. Our goal is to
        help businesses grow faster through innovation and smart technology.
      </p>

      <div className="flex gap-4 flex-wrap">
        <a href="/about">
          <button className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
            Learn More
          </button>
        </a>

        <a href="/portfolio">
          <button className="px-6 py-3 border border-white rounded-lg hover:bg-white hover:text-black transition">
            Our Work
          </button>
        </a>
      </div>
    </div>

    {/* RIGHT GLASS CARD */}
    <div className="bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-2xl animate-slideRight hover:scale-105 transition">

      <h3 className="text-2xl font-semibold mb-4 text-purple-300">
        Why Choose Us?
      </h3>

      <ul className="space-y-3 text-gray-300">
        <li>✔ Modern & Scalable Solutions</li>
        <li>✔ Creative UI/UX Design</li>
        <li>✔ Fast & Secure Development</li>
        <li>✔ Business Growth Focused</li>
      </ul>

    </div>
  </div>
</section>

      {/* ================= SERVICES ================= */}
      <section
        className="py-20 px-6 relative"
        style={{
          backgroundImage: `url(${services})`,
          backgroundSize: "cover",
        }}
      >
        <div className="absolute inset-0 bg-black/80"></div>

        <div className="relative z-10 max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-12">Our Services</h2>

          <div className="grid md:grid-cols-3 gap-8">

            {[
              "Web Development",
              "UI/UX Design",
              "SEO & Marketing",
            ].map((item, i) => (
              <div
                key={i}
                className="p-6 bg-white/10 backdrop-blur-md rounded-xl hover:scale-105 transition"
              >
                <h3 className="text-xl font-semibold mb-3">{item}</h3>
                <p className="text-gray-300">
                  High-quality solutions tailored for your business success.
                </p>
              </div>
            ))}

          </div>

          <Link to="/services">
            <button className="mt-10 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
              Explore Services
            </button>
          </Link>
        </div>
      </section>

     {/* ================= CEO (ENHANCED) ================= */}
<section
  className="relative py-24 px-6"
  style={{
    backgroundImage: `url(${ceo})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-black/85"></div>

  <div className="relative z-10 max-w-5xl mx-auto text-center">

    {/* CEO Image (Floating Style) */}
    <img
      src={ceo}
      alt="CEO"
      className="w-32 h-32 object-cover rounded-full mx-auto mb-6 border-4 border-purple-500 shadow-lg animate-float"
    />

    {/* Heading */}
    <h2 className="text-4xl font-bold mb-4">
      Message from CEO
    </h2>

    {/* Quote */}
    <p className="text-gray-300 italic text-lg leading-relaxed max-w-3xl mx-auto mb-6">
      "At TheLogicWaves, we don't just build websites — we build digital
      experiences that create impact, drive growth, and shape the future
      of businesses."
    </p>

    {/* Name */}
    <h3 className="text-xl font-semibold text-purple-400 mb-6">
      — CEO, TheLogicWaves
    </h3>
     <h3 className="text-xl font-semibold text-purple-400 mb-6">
      FARHEEN AHMAD
    </h3>

    {/* Button */}
    <a href="/CEO">
      <button className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:scale-105 transition">
        Read Full Story
      </button>
    </a>

  </div>
</section>

      {/* ================= CONTACT ================= */}
      <section
        className="py-20 text-center relative"
        style={{
          backgroundImage: `url(${contact})`,
          backgroundSize: "cover",
        }}
      >
        <div className="absolute inset-0 bg-black/75"></div>

        <div className="relative z-10">
          <h2 className="text-4xl font-bold mb-4">
            Let’s Work Together
          </h2>

          <p className="mb-6 text-gray-300">
            Have a project in mind? Let’s bring it to life.
          </p>

          <Link to="/contact">
            <button className="px-8 py-3 bg-white text-black rounded-lg hover:scale-105 transition">
              Contact Us
            </button>
          </Link>
        </div>
      </section>

    </div>
  );
};

export default Home;